import { Label, RadioButton, Text } from '@joor/design-system'
import styled from 'styled-components'

import {
  DefaultContainer,
  commonTextProps,
} from '../../ReassignConnectionsModal.ui'
import IDs from '../../reassignConnectionsModal.ids'
import messages, {
  ACTION_LABELS,
} from '../../reassignConnectionsModal.messages'
import { Actions } from '../../reassignConnectionsModal.types'
import useStore from '../../store/useReassignConnectionsStore'

const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  div {
    margin: 0;
  }
`

const ActionContainer = styled(DefaultContainer)`
  border: 1px solid var(--color-primary-400);
  cursor: pointer;
  &:hover,
  &.selected {
    border: 1px solid var(--color-secondary-400);

    span {
      border-radius: 8px;
      background-color: var(--color-secondary-200);

      svg {
        --main-color: var(--color-secondary-700);
      }
    }
  }
`

const StyledRadioButton = styled(RadioButton)`
  margin-right: 4px;
`

interface ReassignActionsProps {
  isLoading: boolean
}

const ReassignActions = ({
  isLoading,
}: ReassignActionsProps): JSX.Element | null => {
  const action = useStore((state) => state.action)
  const setAction = useStore((state) => state.setAction)
  const sourceUser = useStore((state) => state.sourceUser)

  if (!sourceUser) {
    return null
  }

  return (
    <ActionsContainer>
      <Label $isDisabled={false} $hasError={false}>
        {messages.chooseAction}
      </Label>
      <ActionContainer
        id={IDs.ActionReassign}
        data-testid={IDs.ActionReassign}
        className={action === Actions.REASSIGN ? 'selected' : ''}
        onClick={() => {
          if (isLoading) return
          setAction({ action: Actions.REASSIGN })
        }}
      >
        <StyledRadioButton
          id={IDs.ActionReassign}
          checked={action === Actions.REASSIGN}
        />
        <div>
          <Text {...commonTextProps} fontWeight="bold">
            {ACTION_LABELS[Actions.REASSIGN]}
          </Text>
          <Text {...commonTextProps}>
            {messages.transferNConnections.replace(
              '{amount}',
              sourceUser.numberConnections?.toString() || '',
            )}
          </Text>
        </div>
      </ActionContainer>
      <ActionContainer
        id={IDs.ActionRemove}
        data-testid={IDs.ActionRemove}
        className={action === Actions.REMOVE ? 'selected' : ''}
        onClick={() => {
          if (isLoading) return
          setAction({ action: Actions.REMOVE })
        }}
      >
        <StyledRadioButton
          id={IDs.ActionRemove}
          checked={action === Actions.REMOVE}
        />
        <div>
          <Text {...commonTextProps} fontWeight="bold">
            {ACTION_LABELS[Actions.REMOVE]}
          </Text>
          <Text {...commonTextProps}>
            {messages.removeThisRepFromNConnections.replace(
              '{amount}',
              sourceUser.numberConnections?.toString() || '',
            )}
          </Text>
        </div>
      </ActionContainer>
    </ActionsContainer>
  )
}

export default ReassignActions
